import { ChatStatus } from '../../chat/chat-status.enum';
var WhatsappChannelDataBuilder = /** @class */ (function () {
    function WhatsappChannelDataBuilder() {
        this.whatsappChannelData = {
            participantIds: [],
            activeParticipantIds: [],
            chatId: '111-000',
            chatStatus: ChatStatus.WAITING,
            chatStatusLastUpdateDate: 0,
        };
    }
    WhatsappChannelDataBuilder.prototype.withParticipantIds = function (participantIds) {
        this.whatsappChannelData.participantIds = participantIds;
        return this;
    };
    WhatsappChannelDataBuilder.prototype.withActiveParticipantIds = function (activeParticipantIds) {
        this.whatsappChannelData.activeParticipantIds = activeParticipantIds;
        return this;
    };
    WhatsappChannelDataBuilder.prototype.withChatId = function (chatId) {
        this.whatsappChannelData.chatId = chatId;
        return this;
    };
    WhatsappChannelDataBuilder.prototype.withChatStatus = function (chatStatus) {
        this.whatsappChannelData.chatStatus = chatStatus;
        return this;
    };
    WhatsappChannelDataBuilder.prototype.withChatStatusLastUpdateDate = function (chatStatusLastUpdateDate) {
        this.whatsappChannelData.chatStatusLastUpdateDate = chatStatusLastUpdateDate;
        return this;
    };
    WhatsappChannelDataBuilder.prototype.withLineId = function (lineId) {
        this.whatsappChannelData.lineId = lineId;
        return this;
    };
    WhatsappChannelDataBuilder.prototype.build = function () {
        return this.whatsappChannelData;
    };
    return WhatsappChannelDataBuilder;
}());
export { WhatsappChannelDataBuilder };
//# sourceMappingURL=whatsapp-channel-data.builder.js.map